export class AuthEvents {
  static ON_AUTH_ERROR = 0;
  static ON_AUTH_LOGOUT =  1;
  static ON_AUTH_REFRESH_ERROR =  2;
  static ON_AUTH_REFRESH_SUCCESS =  3;
  static ON_AUTH_SUCCESS =  4;
  static ON_READY =  5;
  static ON_TOKEN_EXPIRED =  6;
}
